import hyphenator from "./hyphenator.js";

/**
 * This represents a language the application can be translated into.
 *
 * @param {string} code - A "xx-XX" string represing the locale.
 * @param {object} [translations] - A dictionary mapping translatable
 * keys to translations in the locale.
 * @param {object} numbroLanguage - Some data provided by the numbro
 * library for this locale.
 * @param {string} flagCssClass - A CSS class for a picture
 * representing the locale.
 * @param {Renderable} name - A user-visible text describing the
 * locale (e.g., "English").
 * @param {boolean} visible - Is the user able to see this locale.
 * @param {string} [hyphenation] - Language code for the hyphenation
 * library. Not specifying this deactivates hyphenation for this
 * language.
 */
export default class Locale {
	constructor({
		code,
		translations,
		numbroLanguage,
		flagCssClass,
		name,
		visible = true,
		hyphenation,
	}) {
		this._code = code;
		this._translations = translations;
		this._numbroLanguage = numbroLanguage;
		this._flagCssClass = flagCssClass;
		this._name = name;
		this._visible = visible;
		this._hyphenationLang = hyphenation;
	}

	getCode() {
		return this._code;
	}

	setTranslations(translations) {
		this._translations = translations;
	}

	getTranslation(key) {
		return this._translations[key];
	}

	getFlagCssClass() {
		return this._flagCssClass;
	}

	getName() {
		return this._name;
	}

	isVisible() {
		return this._visible;
	}

	hasTranslations() {
		return !!this._translations;
	}

	hyphenate(object) {
		if (this._hyphenationLang) {
			return hyphenator.hyphenate(object, this._hyphenationLang);
		}
		return object;
	}

	registerIn(numbro) {
		if (!this._numbroLanguage) {
			return;
		}
		numbro.registerLanguage(this._numbroLanguage);
	}
}
